// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import type { Model } from "../types.ts";

export const AZURE_OPENAI_RESPONSES_MODELS = {
	"gpt-4": {
		id: "gpt-4",
		name: "GPT-4",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: false,
		input: ["text"],
		cost: {
			input: 30,
			output: 60,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 8192,
		maxTokens: 8192,
	} satisfies Model<"azure-openai-responses">,
	"gpt-4-turbo": {
		id: "gpt-4-turbo",
		name: "GPT-4 Turbo",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 10,
			output: 30,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"azure-openai-responses">,
	"gpt-4.1": {
		id: "gpt-4.1",
		name: "GPT-4.1",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 8,
			cacheRead: 0.5,
			cacheWrite: 0,
		},
		contextWindow: 1047576,
		maxTokens: 32768,
	} satisfies Model<"azure-openai-responses">,
	"gpt-4.1-mini": {
		id: "gpt-4.1-mini",
		name: "GPT-4.1 mini",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.4,
			output: 1.6,
			cacheRead: 0.1,
			cacheWrite: 0,
		},
		contextWindow: 1047576,
		maxTokens: 32768,
	} satisfies Model<"azure-openai-responses">,
	"gpt-4.1-nano": {
		id: "gpt-4.1-nano",
		name: "GPT-4.1 nano",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.1,
			output: 0.4,
			cacheRead: 0.025,
			cacheWrite: 0,
		},
		contextWindow: 1047576,
		maxTokens: 32768,
	} satisfies Model<"azure-openai-responses">,
	"gpt-4o": {
		id: "gpt-4o",
		name: "GPT-4o",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 2.5,
			output: 10,
			cacheRead: 1.25,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"azure-openai-responses">,
	"gpt-4o-2024-05-13": {
		id: "gpt-4o-2024-05-13",
		name: "GPT-4o (2024-05-13)",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 15,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 4096,
	} satisfies Model<"azure-openai-responses">,
	"gpt-4o-2024-08-06": {
		id: "gpt-4o-2024-08-06",
		name: "GPT-4o (2024-08-06)",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 2.5,
			output: 10,
			cacheRead: 1.25,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"azure-openai-responses">,
	"gpt-4o-2024-11-20": {
		id: "gpt-4o-2024-11-20",
		name: "GPT-4o (2024-11-20)",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 2.5,
			output: 10,
			cacheRead: 1.25,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"azure-openai-responses">,
	"gpt-4o-mini": {
		id: "gpt-4o-mini",
		name: "GPT-4o mini",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: false,
		input: ["text", "image"],
		cost: {
			input: 0.15,
			output: 0.6,
			cacheRead: 0.075,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5": {
		id: "gpt-5",
		name: "GPT-5",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5-chat-latest": {
		id: "gpt-5-chat-latest",
		name: "GPT-5 Chat Latest",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: false,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5-codex": {
		id: "gpt-5-codex",
		name: "GPT-5-Codex",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5-mini": {
		id: "gpt-5-mini",
		name: "GPT-5 Mini",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 2,
			cacheRead: 0.025,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5-nano": {
		id: "gpt-5-nano",
		name: "GPT-5 Nano",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 0.05,
			output: 0.4,
			cacheRead: 0.005,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5-pro": {
		id: "gpt-5-pro",
		name: "GPT-5 Pro",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 15,
			output: 120,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.1": {
		id: "gpt-5.1",
		name: "GPT-5.1",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.1-chat-latest": {
		id: "gpt-5.1-chat-latest",
		name: "GPT-5.1 Chat",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.1-codex": {
		id: "gpt-5.1-codex",
		name: "GPT-5.1 Codex",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.1-codex-max": {
		id: "gpt-5.1-codex-max",
		name: "GPT-5.1 Codex Max",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 1.25,
			output: 10,
			cacheRead: 0.125,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.1-codex-mini": {
		id: "gpt-5.1-codex-mini",
		name: "GPT-5.1 Codex mini",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null},
		input: ["text", "image"],
		cost: {
			input: 0.25,
			output: 2,
			cacheRead: 0.025,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.2": {
		id: "gpt-5.2",
		name: "GPT-5.2",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1.75,
			output: 14,
			cacheRead: 0.175,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.2-chat-latest": {
		id: "gpt-5.2-chat-latest",
		name: "GPT-5.2 Chat",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1.75,
			output: 14,
			cacheRead: 0.175,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.2-codex": {
		id: "gpt-5.2-codex",
		name: "GPT-5.2 Codex",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1.75,
			output: 14,
			cacheRead: 0.175,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.2-pro": {
		id: "gpt-5.2-pro",
		name: "GPT-5.2 Pro",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 21,
			output: 168,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.3-chat-latest": {
		id: "gpt-5.3-chat-latest",
		name: "GPT-5.3 Chat (latest)",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: false,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1.75,
			output: 14,
			cacheRead: 0.175,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 16384,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.3-codex": {
		id: "gpt-5.3-codex",
		name: "GPT-5.3 Codex",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1.75,
			output: 14,
			cacheRead: 0.175,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.3-codex-spark": {
		id: "gpt-5.3-codex-spark",
		name: "GPT-5.3 Codex Spark",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 1.75,
			output: 14,
			cacheRead: 0.175,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 32000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.4": {
		id: "gpt-5.4",
		name: "GPT-5.4",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 2.5,
			output: 15,
			cacheRead: 0.25,
			cacheWrite: 0,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.4-mini": {
		id: "gpt-5.4-mini",
		name: "GPT-5.4 mini",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 0.75,
			output: 4.5,
			cacheRead: 0.075,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.4-nano": {
		id: "gpt-5.4-nano",
		name: "GPT-5.4 nano",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 0.2,
			output: 1.25,
			cacheRead: 0.02,
			cacheWrite: 0,
		},
		contextWindow: 400000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.4-pro": {
		id: "gpt-5.4-pro",
		name: "GPT-5.4 Pro",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 30,
			output: 180,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.5": {
		id: "gpt-5.5",
		name: "GPT-5.5",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 30,
			cacheRead: 0.5,
			cacheWrite: 0,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.5-pro": {
		id: "gpt-5.5-pro",
		name: "GPT-5.5 Pro",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh","minimal":null,"low":null},
		input: ["text", "image"],
		cost: {
			input: 30,
			output: 180,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.6-luna": {
		id: "gpt-5.6-luna",
		name: "GPT-5.6 Luna",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 1,
			output: 6,
			cacheRead: 0.1,
			cacheWrite: 1.25,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.6-sol": {
		id: "gpt-5.6-sol",
		name: "GPT-5.6 Sol",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 5,
			output: 30,
			cacheRead: 0.5,
			cacheWrite: 6.25,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-5.6-terra": {
		id: "gpt-5.6-terra",
		name: "GPT-5.6 Terra",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		thinkingLevelMap: {"off":null,"xhigh":"xhigh","max":"max"},
		input: ["text", "image"],
		cost: {
			input: 2.5,
			output: 15,
			cacheRead: 0.25,
			cacheWrite: 3.125,
		},
		contextWindow: 1050000,
		maxTokens: 128000,
	} satisfies Model<"azure-openai-responses">,
	"gpt-realtime-2.1": {
		id: "gpt-realtime-2.1",
		name: "GPT-Realtime-2.1",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 4,
			output: 24,
			cacheRead: 0.4,
			cacheWrite: 0,
		},
		contextWindow: 128000,
		maxTokens: 32000,
	} satisfies Model<"azure-openai-responses">,
	"o1": {
		id: "o1",
		name: "o1",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 15,
			output: 60,
			cacheRead: 7.5,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 100000,
	} satisfies Model<"azure-openai-responses">,
	"o1-pro": {
		id: "o1-pro",
		name: "o1-pro",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 150,
			output: 600,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 100000,
	} satisfies Model<"azure-openai-responses">,
	"o3": {
		id: "o3",
		name: "o3",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 8,
			cacheRead: 0.5,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 100000,
	} satisfies Model<"azure-openai-responses">,
	"o3-deep-research": {
		id: "o3-deep-research",
		name: "o3-deep-research",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 10,
			output: 40,
			cacheRead: 2.5,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 100000,
	} satisfies Model<"azure-openai-responses">,
	"o3-mini": {
		id: "o3-mini",
		name: "o3-mini",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		input: ["text"],
		cost: {
			input: 1.1,
			output: 4.4,
			cacheRead: 0.55,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 100000,
	} satisfies Model<"azure-openai-responses">,
	"o3-pro": {
		id: "o3-pro",
		name: "o3-pro",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 20,
			output: 80,
			cacheRead: 0,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 100000,
	} satisfies Model<"azure-openai-responses">,
	"o4-mini": {
		id: "o4-mini",
		name: "o4-mini",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 1.1,
			output: 4.4,
			cacheRead: 0.275,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 100000,
	} satisfies Model<"azure-openai-responses">,
	"o4-mini-deep-research": {
		id: "o4-mini-deep-research",
		name: "o4-mini-deep-research",
		api: "azure-openai-responses",
		provider: "azure-openai-responses",
		baseUrl: "",
		reasoning: true,
		input: ["text", "image"],
		cost: {
			input: 2,
			output: 8,
			cacheRead: 0.5,
			cacheWrite: 0,
		},
		contextWindow: 200000,
		maxTokens: 100000,
	} satisfies Model<"azure-openai-responses">,
} as const;
